(() => {
  const cfg = (window.__SWIPE_NAV__ || {});
  const mql = window.matchMedia(cfg.mediaQuery || '(max-width: 749px)');
  if (!mql.matches) return;

  // Helpers
  const px = (n) => (typeof n === 'number' ? n : 60);
  const THRESHOLD = px(cfg.threshold);
  const EDGE_GUTTER = 24; // px from left/right edges to start, when edgeOnly = true

  // Elements/areas to ignore (carousels, scrollers, inputs, opened drawers)
  const isScrollable = (el) => {
    if (!el || el === document.body) return false;
    const style = window.getComputedStyle(el);
    const overflowX = style.overflowX;
    const overflowY = style.overflowY;
    const canScroll = (v) => v === 'auto' || v === 'scroll';
    if (canScroll(overflowX) || canScroll(overflowY)) return true;
    return isScrollable(el.parentElement);
  };

  const isInteractive = (el) => {
    const tag = (el.tagName || '').toLowerCase();
    return /^(a|button|input|textarea|select|label|summary|video|audio)$/.test(tag) || el.isContentEditable;
  };

  const selectorOpenBlocks = [
    '.menu-drawer__navigation details[open]',
    '.menu-drawer-container details[open]',
    '.modal[open]',
    '.cart-notification.is-visible',
    '.drawer.is-open',
    '.cart-drawer.is-open'
  ];

  const anyOverlayOpen = () => {
    try {
      return selectorOpenBlocks.some(sel => document.querySelector(sel));
    } catch {
      return false;
    }
  };

  // Track touches
  let startX = 0, startY = 0, startTime = 0, startTarget = null;

  const onTouchStart = (e) => {
    if (anyOverlayOpen()) return;
    const t = e.changedTouches && e.changedTouches[0];
    if (!t) return;

    startX = t.clientX;
    startY = t.clientY;
    startTime = Date.now();
    startTarget = e.target;

    // Optional: Only allow from screen edges
    if (cfg.edgeOnly) {
      const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      const leftEdge = startX <= EDGE_GUTTER;
      const rightEdge = startX >= vw - EDGE_GUTTER;
      // If not from either edge, ignore (but allow forward/back separation later)
      if (!leftEdge && !rightEdge) {
        startTarget = null; // mark as invalid
      }
    }
  };

  const onTouchEnd = (e) => {
    if (!startTime || !startTarget) return;
    const t = e.changedTouches && e.changedTouches[0];
    if (!t) return;

    const dx = t.clientX - startX;
    const dy = t.clientY - startY;

    // reset state
    const elapsed = Date.now() - startTime;
    startTime = 0;

    // Ignore vertical swipes / scroll gestures
    if (Math.abs(dy) > Math.abs(dx)) return;

    // Ignore small swipes
    if (Math.abs(dx) < THRESHOLD) return;

    // Ignore if starting inside interactive or scrollable area
    if (isInteractive(startTarget) || isScrollable(startTarget)) return;

    // Prevent interfering in product/gallery sliders (Dawn uses .slider-component/.slider)
    const closestSlider = (startTarget.closest && startTarget.closest('.slider, .slider-component, .product__media-wrapper, .media') );
    if (closestSlider) return;

    // Navigation rules
    if (dx > 0) {
      // Swipe RIGHT → Back
      history.back();
    } else {
      // Swipe LEFT → Forward (optional)
      if (cfg.forward) {
        // Only go forward if the browser has a forward history
        // Not all browsers expose forward length; graceful attempt:
        history.forward();
      }
    }
  };

  // Attach listeners (passive for perf)
  document.addEventListener('touchstart', onTouchStart, { passive: true });
  document.addEventListener('touchend', onTouchEnd, { passive: true });

  // Re-evaluate on resize (in case viewport crosses the breakpoint)
  const onChange = () => {
    if (!mql.matches) {
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchend', onTouchEnd);
    }
  };
  mql.addEventListener ? mql.addEventListener('change', onChange) : mql.addListener(onChange);
})();
